import { Text } from '@/components/commons/typography/Text'
import { Avatar } from 'containers/recommendations/Avatar'
import { BrowserContext } from 'context'
import { ReactNode, useContext } from 'react'
import { SkeletonNotification } from './NotificationLoading'

interface NotificationBaseProps {
  mainAvatar?: string
  mainUsername?: string
  secondaryAvatar?: string
  secondaryUsername?: string
  time?: string
  children: ReactNode
  loading?: boolean
}

export const NotificationBase = ({
  mainAvatar,
  mainUsername,
  secondaryAvatar,
  secondaryUsername,
  time,
  children,
  loading,
}: NotificationBaseProps) => {
  const { isMobile } = useContext(BrowserContext)


  const multipleAvatars = mainAvatar && secondaryAvatar

  const forOwnerAvatarSize = isMobile ? 48 : 64
  const forOtherAvatarSize = isMobile ? 40 : 48
  const secondaryAvatarSize = isMobile ? 32 : 40
  const mainAvatarSize = !multipleAvatars ? forOwnerAvatarSize : forOtherAvatarSize

  if (loading) {
    return <SkeletonNotification />
  }

   return (
      <div className='rounded-16 border-solid border-1 border-secondary full-w px-20 py-16'>
        <div className='flex justify-space-between gap-24'>
          <div className='flex gap-20'>
            <div
              style={{
                width: `${forOwnerAvatarSize}px`,
                height: `${forOwnerAvatarSize}px`,
                aspectRatio: '1/1',
                flex: '0 0 auto',
              }} 
              className='relative'>
              <div className={
                multipleAvatars && 'absolute top-0 left-0'
              }>
                <Avatar
                  image={mainAvatar}
                  size={mainAvatarSize}
                  username={mainUsername}
                />
              </div>
              {secondaryAvatar && (
                <div className='absolute -bottom-8 -right-4 bottom-4--desktop right-6--desktop'>
                  <Avatar
                    image={secondaryAvatar}
                    size={secondaryAvatarSize}
                    username={secondaryUsername}
                  />
                </div>
              )}
            </div>
            
            {children}
          </div>
          {time && (
            <div style={{
              flex: '0 0 auto',
            }}>
              <Text variation='xSmall' colorClass='text-secondary'>{time}</Text>
            </div>
          )}
        </div>
      </div>
    )
}
